import customFetchBase from "../../../principal/customFetchBase";
import {createApi} from "@reduxjs/toolkit/query/react";

export const carrerasApi = createApi({
  reducerPath: "carrerasApi",
  baseQuery: customFetchBase,
  tagTypes: ["Carreras", "Niveles", "Duracion"],
  endpoints: () => ({}),
});
